export enum DELIVERY_SECTION_CALLOUT_VARIANT {
    BOTTOM_PADDING = "bottom-padding",
    TOP_PADDING = "top-padding",
}

export const CALLOUT_BUBBLE_BACKGROUND =
    "linear-gradient(89deg, rgba(245, 245, 250, 0.8) -0.28%, rgba(245, 245, 250, 0.4) 82.93%, rgba(255, 255, 255, 0.66) 99.47%)";
